import React from "react";
import Balipic from '../assets/cbu/bali3.png'
import Baligedung from '../assets/cbu/bali4.png'
import Sewa from '../assets/cbu/bali2.png'
import Harga from '../assets/cbu/bali5.png'
import Girl from '../assets/cbu/bali1.png'
import Mobilpic from '../assets/cbu/bali6.png'
import "../css/Bali.css"
import { motion } from "framer-motion"


function Bali() {
  return ( 
    <section id="bali">

      <motion.img src={Mobilpic} class="gambarmobil"   alt="..." 
            initial={{ opacity: 0 }} // Starting state
            whileInView={{ opacity: 1, transition: {delay:0.4, duration:0.6}}} // When the element comes 
            into view
            transition={{ duration: 0.3 }}
            useMotionValueEvent={{y:'100px'}}/>
        <div> 
           <div class="gambarharga">
                <motion.img src={Harga} class="img-fluid" alt="..." 
                      initial={{ opacity: 0 }} // Starting state
                      whileInView={{ opacity: 1, transition: {delay:0.5, duration:0.6}}} // When the element comes 
                      into view
                      transition={{ duration: 0.3 }}
                      useMotionValueEvent={{y:'100px'}}
                />
          </div>
          <div class="gambarsewa">
                <motion.img src={Sewa} class="img-fluid" alt="..." 
                      initial={{ opacity: 0 }} // Starting state
                      whileInView={{ opacity: 1, transition: {delay:0.3, duration:0.6}}} // When the element comes 
                      into view
                      transition={{ duration: 0.3 }}
                      useMotionValueEvent={{y:'100px'}}/>
          </div>
          <div class="gambargedung">
                <img src={Baligedung} class="img-fluid" loading="eager" alt="..." />
          </div>
          <div class="gambar-content">
            <div class="gambarbali">
                <img src={Balipic} class="img-fluid" loading="eager" alt="..." />
            </div>
           
          </div>
          <div class="gambargirl">
                <img src={Girl} class="img-fluid" loading="eager" alt="..." />
          </div>
        </div>
        
   </section>
  );
}
   
export default Bali;